import React from 'react';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { BenefitCard } from './components/BenefitCard';
import { wellnessBenefitsData1, wellnessBenefitsData2 } from './data';
export const WellnessBenefitsSection = () => <Container mt={5} data-sentry-element="Container" data-sentry-component="WellnessBenefitsSection" data-sentry-source-file="index.tsx">
    <SectionHeading fontSize={['24px', null, '30px']} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
      The benefits of Wag! Wellness
    </SectionHeading>
    <Flex flexDirection={['column', null, 'row', null]} justifyContent="space-between" mt={4} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Box flex={1} mr={[0, null, '10px', null]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {wellnessBenefitsData1.map(({
        body,
        labels,
        title
      }) => <BenefitCard key={title} body={body} labels={labels} title={title} mb={['12px', null, '20px', null]} />)}
      </Box>

      <Box flex={1} ml={[0, null, '10px', null]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {wellnessBenefitsData2.map(({
        body,
        labels,
        title
      }) => <BenefitCard key={title} body={body} labels={labels} title={title} mb={['12px', null, '20px', null]} />)}
      </Box>
    </Flex>
  </Container>;